import { Component, Input, ViewEncapsulation } from '@angular/core';
import { EnterFadeInAnimation } from '@nha/components/animations';


@Component({
    selector: 'nha-loader',
    template: `
		@if (loading) {
		  <div class="nha-loader" [@enterFadeIn]>
		    <div class="circle"></div>
		    <div class="circle"></div>
		    <div class="circle"></div>
		  </div>
		}
		
		@if (!loading) {
		  <ng-content></ng-content>
		}
		`,
    animations: [EnterFadeInAnimation],
    encapsulation: ViewEncapsulation.None,
    imports: []
})
export class NHALoaderComponent {
	@Input() loading: boolean = false;
}
